import { APIClient } from "../helpers/api_helper";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";
import {
  CreateServicePayload,
  Service,
  ServiceRecipeItemPayload,
  UpdateServicePayload,
} from "../types/service";

const api = new APIClient();

const RESOURCE = "/services";

export type {
  Service,
  CreateServicePayload,
  UpdateServicePayload,
  ServiceRecipeItemPayload,
};

export interface ServiceListParams extends PaginationParams {
  unit_id?: number;
  category_id?: number;
  search?: string;
}

export const getServices = (
  params?: ServiceListParams
): Promise<PaginatedApiResponse<Service>> =>
  api.get<PaginatedApiResponse<Service>>(RESOURCE, params);

export const getService = (id: number): Promise<ApiResponse<Service>> =>
  api.get<ApiResponse<Service>>(`${RESOURCE}/${id}`);

export const createService = (
  payload: CreateServicePayload
): Promise<ApiResponse<Service>> =>
  api.create<ApiResponse<Service>>(RESOURCE, payload);

export const updateService = (
  id: number,
  payload: UpdateServicePayload
): Promise<ApiResponse<Service>> =>
  api.update<ApiResponse<Service>>(`${RESOURCE}/${id}`, payload);

export const deleteService = (
  id: number
): Promise<ApiResponse<Record<string, never>>> =>
  api.delete<ApiResponse<Record<string, never>>>(`${RESOURCE}/${id}`);

export const syncServiceRecipe = (
  serviceId: number,
  items: ServiceRecipeItemPayload[]
): Promise<ApiResponse<Service>> =>
  api.create<ApiResponse<Service>>(`${RESOURCE}/${serviceId}/recipe`, { items });
